module.exports = "<symbol id=\"thebestco-uikit-svg-UpThin16\" viewBox=\"0 0 18 18\"><path d=\"M1 13L9 5L17 13\"/></symbol>";